import React from "react";
import { Link } from "react-router-dom";

import bg1 from '../../assets/images/bg/bg-about.jpg'
import Navbar from "../../components/navbar";
import Footer from '../../components/footer';
import { aboutData, aboutImage, startUpCounter, teamData } from "../../data/data";

import { FiArrowRight, FiMail } from '../../assets/icons/icons'
import Masonry, {ResponsiveMasonry} from "react-responsive-masonry"
import CountUp from 'react-countup';
import ScrollTop from "../../components/scrollTop";

export default function PageAbout(){
    return(
        <>
        <Navbar navLight={true}/>
        <section className="bg-half-170 d-table w-100" style={{backgroundImage:`url(${bg1})`}}>
            <div className="bg-overlay"></div>
            <div className="container">
                <div className="row mt-5 justify-content-center">
                    <div className="col-12">
                        <div className="heading-title text-center">
                            <h2 className="text-white title  title-dark mb-3">About us</h2>
                            <p className="para-desc mx-auto text-white-50">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                            <div className="mt-4 pt-2">
                                <Link to="#" className="btn btn-light">Read Our Story</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <div className="position-relative">
            <div className="shape overflow-hidden text-white">
                <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
                </svg>
            </div>
        </div>

        <section className="section">
            <div className="container">
                <div className="row">
                    <div className="col-md-6">
                        <div className="section-title mb-4 pb-2 mb-sm-0 pb-sm-0 me-lg-5">
                            <h6 className="text-primary">Our Story</h6>
                            <h4 className="title mb-0 me-lg-5">Tools should adapt to the user, not the other way around.</h4>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="section-title">
                            <p className="text-muted para-desc"> It is said that song composers of the past used dummy texts as lyrics when writing melodies in order to have a 'ready-made' text to sing with the melody. Dummy texts have been in use by typesetters since the 16th century.</p>
                            <p className="text-muted para-desc mb-0">If the distribution of letters and 'words' is random, the reader will not be distracted from making a neutral judgement on the visual impact and readability.</p>
                        </div>
                    </div>
                </div>

                <div className="row mt-4 pt-2">
                    {aboutData.map((item, index) =>{
                        let Icon = item.icon
                        return(
                            <div className="col-lg-4 col-md-6 mt-4 pt-2" key={index}>
                                <div className="card border-0 text-center features feature-primary rounded">
                                    <div className="icon text-center mx-auto rounded-md">
                                        <h3 className="mb-0"><Icon/></h3>
                                    </div>

                                    <div className="card-body p-0 mt-4">
                                        <h5>{item.title}</h5>
                                        <p className="text-muted mb-0">{item.desc}</p>
                                        <div className="mt-2">
                                            <Link to="#" className="link">Read More <FiArrowRight className="fea icon-sm"/></Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>

            <div className="container mt-100 mt-60">
                <ResponsiveMasonry
                    columnsCountBreakPoints={{350: 1, 750: 2, 900: 4}}
                >
                    <Masonry>
                        {aboutImage.map((item, index) =>{
                            return(
                                <div className=" spacing picture-item" key={index}>
                                    <div className="card border-0 position-relative d-block shadow overflow-hidden rounded">
                                        <div className="card-body p-0">
                                            <img src={item} className="img-fluid" alt=""/>
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </Masonry>
                </ResponsiveMasonry>
            </div>

            <div className="container mt-100 mt-60">
                <div className="row justify-content-center">
                    <div className="col-lg-9">
                        <div className="row" id="counter">
                            {startUpCounter.map((item, index) =>{
                                return(
                                <div className="col-md-4 mt-4 pt-2" key={index}>
                                    <div className="counter-box text-center">
                                        <h1 className="mb-0"><CountUp className="counter-value" end={item.number} start={0} />%</h1>
                                        <h6 className="counter-head text-muted">{item.title}</h6>
                                    </div>
                                </div> 
                                )
                            })}
                        </div>
                    </div>
                </div>
            </div>

            <div className="container mt-100 mt-60">
                <div className="row justify-content-center">
                    <div className="col-12">
                        <div className="section-title text-center mb-4 pb-2">
                            <h6 className="text-primary">Our Team</h6>
                            <h4 className="title mb-4">Creative Team Members</h4>
                            <p className="text-muted para-desc mx-auto mb-0">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                        </div>
                    </div>
                </div>

                <div className="row">
                    {teamData.slice(0,4).map((item, index) =>{
                        return(
                            <div className="col-lg-3 col-md-6 col-12 mt-4 pt-2" key={index}>
                                <div className="card text-center team border-0 shadow rounded overflow-hidden">
                                    <img src={item.image} className="img-fluid" alt=""/>
                                    <div className="card-body py-3 content">
                                        <h5 className="mb-0">{item.name}</h5>
                                        <h6 className="text-muted mb-0">{item.title}</h6>
                                    </div>
                                    <ul className="list-unstyled team-social mb-0">
                                        <li><Link to="mailto:contact@example.com" className="btn btn-icon btn-pills btn-soft-primary"><FiMail className="icons"/></Link></li>
                                    </ul>
                                </div>
                            </div>
                        )
                    })}

                    <div className="col-12 text-center mt-4 pt-2">
                        <div className="alert alert-light alert-pills" role="alert">
                            <span className="badge bg-danger rounded-pill me-1">Jobs</span>
                            <span className="content">We Are Hiring <Link to="#" className="text-primary"> Send your CV / Resume</Link></span>
                         </div>
                    </div>
                </div>
            </div>
        </section>
        <Footer/>
        <ScrollTop/>
        </>
    )
}